import { Button, Container, Grid, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import { EMAIL_FORGOT_PASSWORD_PATH } from '../Routes';
import useStores from '../stores/UseStores';

const ForcePasswordReset = observer((): React.JSX.Element => {
  const {
    routeStore: { route },
    translateStore: { translate },
  } = useStores();

  return (
    <Container>
      <Notice type={'error'}>
        <span>{translate('forcePasswordReset.description')}</span>
      </Notice>
      <Separator spacing={'small'} color={'invisible'} />
      <Grid align={['center-sm']}>
        <Button text={translate('forcePasswordReset.updatePassword')} onClick={() => route(EMAIL_FORGOT_PASSWORD_PATH)} />
      </Grid>
    </Container>
  );
});

export default ForcePasswordReset;
